import { resolveBaseState } from './resolvers/base.resolver';

export default [ '$stateProvider', $stateProvider => {
  $stateProvider
    .state('app', {
      abstract: true,
      url: '',
      component: 'app',
      resolve: {
        state: resolveBaseState(),
      },
      roles: []
    })
    .state('app.admin', {
      abstract: true,
      url: '/admin',
      template: '<div ui-view></div>',
      roles: []
    });
} ];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/base.routes.js